import { Box, createStyles, Divider, Space, Text } from '@mantine/core';
import React, { useState } from 'react';
import DocumentLayout from './DocumentLayoutSettings';
import { MediaUpload } from './MediaUpload';

const useStyles = createStyles((theme) => ({
  page: {
    minWidth: 0,
  },
  header: {
    padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
  },
}));

const DocumentSettings = () => {
  const { classes } = useStyles();
  const [logoAvailable, setLogoAvailable] = useState(false);
  const [lastModified, setLastModified] = useState(undefined);

  return (
    <Box className={classes.page}>
      <DocumentLayout
        lastModified={lastModified}
        logoAvailable={logoAvailable}
        logoSettings={
          <MediaUpload
            compact
            kind="logo"
            title="Logo"
            text="PNG, JPG oder SVG hochladen"
            setLastModified={setLastModified}
            setLogoUploaded={setLogoAvailable}
            lastModified={lastModified}
          />
        }
        backgroundSettings={
          <>
            <Divider label="Hintergrund" labelPosition="center" />
            <Box>
              <MediaUpload
                compact
                kind="notepaper"
                title="Seite 1"
                text="Briefpapier oder vollflächiges Motiv"
                setLastModified={setLastModified}
                lastModified={lastModified}
              />
              <Space h="xs" />
              <MediaUpload
                compact
                kind="background-starting-page-2"
                title="Folgeseiten"
                text="Wird automatisch ab Seite 2 verwendet"
                setLastModified={setLastModified}
                lastModified={lastModified}
              />
            </Box>
          </>
        }
      />
    </Box>
  );
};

export default DocumentSettings;
